/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { HttpResponseAPI } from '../models/httpResponse';
import { ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { RegistroHoras } from '../models/registro-horas.model';

@Injectable({
    providedIn: 'root'
})
export class RegistroService {

    private nombreServicio: string = 'registrohoras';

    // #region Propiedades públicas
    loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    // #endregion

    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private toastController: ToastController
    ) { }

    /**
     * Comprueba si se ha iniciado el registro de horas para el empleado.
     *
     * @returns Un Observable que emite el resultado de la comprobación del registro. Puede ser un valor del tipo
     */
    public comprobarRegistro(): Observable<RegistroHoras> {
        const url: string = `${environment.apiUrl}/${this.nombreServicio}/obtenerregistro`;
        const cargarToken = from(this.authenticationService.loadToken());

        return new Observable<RegistroHoras>((observer) => {
            this.loading$.next(true);

            cargarToken
                .pipe(
                    concatMap(() => {
                        const headers = new HttpHeaders({
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + this.authenticationService.token
                        });
                        return this.http.get<HttpResponseAPI>(url, { headers });
                    })
                )
                .subscribe({
                    next: (resultado: HttpResponseAPI) => {
                        if (resultado !== null && resultado.data !== null) {
                            observer.next(resultado.data);
                        } else {
                            observer.next(null);
                        }
                    },
                    complete: () => {
                        this.loading$.next(false);
                        observer.complete();
                    }
                });
        });
    }

    /**
     * Finaliza el registro.
     */
    finalizarRegistro(): Observable<boolean> {
        let desplazamientoZona: number = moment().utcOffset();
        const url: string = `${environment.apiUrl}/${this.nombreServicio}/finalizar?offset=${desplazamientoZona}`;
        const cargarToken = from(this.authenticationService.loadToken());

        return new Observable<boolean>((observer) => {
            cargarToken
                .pipe(
                    concatMap(() => {
                        const headers = new HttpHeaders({
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + this.authenticationService.token
                        });
                        return this.http.get<HttpResponseAPI>(url, { headers });
                    })
                )
                .subscribe({
                    next: (resultado: HttpResponseAPI) => {
                        observer.next(resultado?.data !== null ? true : false);

                        // Mostramos un mensaje de confirmación
                        this.toastController.create({
                            message: 'Se ha finalizado el registro de horas correctamente.',
                            duration: 2000,
                            position: 'bottom',
                            color: 'success'
                        }).then((toast) => {
                            toast.present();
                        });
                    }
                });
        });

    }

    /**
     * Inicia el registro.
     */
    iniciarRegistro(): Observable<boolean> {
        let desplazamientoZona: number = moment().utcOffset();
        const url: string = `${environment.apiUrl}/${this.nombreServicio}/iniciar?offset=${desplazamientoZona}`;
        const cargarToken = from(this.authenticationService.loadToken());

        return new Observable<boolean>((observer) => {
            cargarToken
                .pipe(
                    concatMap(() => {
                        const headers = new HttpHeaders({
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + this.authenticationService.token
                        });
                        return this.http.get<HttpResponseAPI>(url, { headers });
                    })
                )
                .subscribe({
                    next: (resultado: HttpResponseAPI) => {
                        observer.next(resultado?.data !== null ? true : false);

                        // Mostramos un mensaje de confirmación
                        this.toastController.create({
                            message: 'Se ha iniciado el registro de horas correctamente.',
                            duration: 2000,
                            position: 'bottom',
                            color: 'success'
                        }).then((toast) => {
                            toast.present();
                        });
                    }
                });
        });
    }
}
